import React, { useState, useEffect, useRef } from 'react';
import { navigate } from 'gatsby';
import ToggleSelect from '../../../common/components/ToggleSelect/ToggleSelect';
import { useFormikContext } from 'formik';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import Styles from './companyDetails.module.css';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import get from 'lodash/get';
import {
  getSelpEmployeedDetails,
  addSelpEmployeedDetails,
  getnatureOfBusinessLists,
  getIndustryLists,
  getSubIndustryData,
  getCompanyDetails,
  lapIndToComp
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { setLapInfo } from '../../../common/utils/LapInfo';
import { staticData } from 'gatsby-env-variables';

import * as _ from 'lodash';
import PopUp from '../../../common/components/PopUp/PopUp';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '../../../common/components/Modal/modal';
const Modaltext = {
  position: 'relative',
  top: '-26px',
  width: '300px'
};

const { compnay_container, comingSoon } = Styles;

const CompanyDetails = ({ lap, getValues }) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [triggeredState, setTegiggerState] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [getCompanyList, setComapnyList] = useState([]);
  const [autoCompleteValue, setAutoCompleteValue] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    validateForm();
  }, []);

  useEffect(() => {
    if (getValues) {
      handleAutoCompletionFiled(getValues);
    }
  }, [getValues]);

  let comanyTypes = [
    ...(!lap
      ? [
          {
            name: 'Proprietorship',
            value: 'Proprietorship'
          }
        ]
      : []),

    {
      name: 'Partnership',
      value: 'Partnership'
    },
    {
      name: 'Limited',
      value: 'Limited'
    },
    {
      name: 'Private Limited',
      value: 'Private Limited'
    },
    {
      name: 'LLP',
      value: 'LLP'
    }
  ];
  const handleAutoCompletionFiled = res => {
    let prevalue = {
      name: _.get(res, 'companyName', ''),
      cin: _.get(res, 'cin', '')
    };
    setComapnyList([prevalue]);
    setAutoCompleteValue(prevalue);
  };
  const getSubmitedData = () => {
    setType('loading');
    setText('Please wait getting information');
    setShow(true);

    getSelpEmployeedDetails(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        setShow(false);

        setFieldValue('isShowFileds', true);
        setFieldValue('companyType', _.get(res, 'companyType', false));
        setFieldValue('auto_complete_cin', _.get(res, 'companyName', ''));
        setFieldValue('company_name', _.get(res, 'companyName', ''));

        if (values.companyType == 'LLP') {
          setFieldValue('cin', _.get(res, 'cin', ''));
        } else {
          setFieldValue('llpin', _.get(res, 'cin', ''));
        }

        setFieldValue('cin', _.get(res, 'cin', ''));
        setFieldValue('nature_of_business', {
          value: _.get(res, 'natureOfBusiness.id', false),
          label: _.get(res, 'natureOfBusiness.name', 'Nature Of Business')
        });
        setFieldValue('industry_list', {
          value: _.get(res, 'industry.id', false),
          label: _.get(res, 'industry.name', 'Choose Industry')
        });
        setFieldValue('sub_industry', {
          value: _.get(res, 'subIndustry.id', false),
          label: _.get(res, 'subIndustry.name', 'Choose Sub Industry')
        });
        setFieldValue('company_pan', _.get(res, 'companyPan', false));
        setFieldValue('gstNumber', _.get(res, 'gstNumber', false));

        setTegiggerState(!triggeredState);
        handleAutoCompletionFiled(res);
      })
      .catch(error => {
        setShow(false);
      });
  };
  useEffect(() => {
    if (!lap) getSubmitedData();
  }, []);
  useEffect(() => {
    setTegiggerState(!triggeredState);
  }, [values.isShowFileds]);

  return (
    <div className={!lap ? 'px-5' : '' + ` w-full my-4  `}>
      <div className={` ${values.isShowFileds ? 'hidden' : 'block'} md:block`}>
        <div className="w-full block ">
          <p className="text-roboto tex-black-850 text-lg font-medium">
            {' '}
            Company Details{' '}
          </p>
          <p className="text-roboto text-black-850 text-base font-medium mt-5">
            {' '}
            Please choose type of company
          </p>
        </div>

        <div className="w-full mt-5 flex flex-wrap ">
          {comanyTypes.map((each, index) => {
            return (
              <div className={`block md:w-auto w-full`}>
                <div className="mx-3 cursor-pointer mt-3 hidden md:block">
                  <ToggleSelect
                    name="companyType"
                    value={each.value}
                    checked={values.companyType === each.value}
                    onChange={e => {
                      handleChange(e);
                      setFieldValue('companyType', each.value);
                      setTegiggerState(!triggeredState);
                    }}
                    nameDisplay={each.name}
                    containerStyle={{
                      width: '7.5rem',
                      height: '100px',
                      alignItems: 'center'
                    }}
                    namingStyle={{ marginTop: '38px', fontSize: '14px' }}
                    key={index}
                  />
                </div>

                <div className="block w-full md:hidden flex my-3">
                  <div className="font-robot font-normal text-sm text-grey-2000 mr-auto ">
                    {each.name}
                  </div>
                  <div className="ml-auto" style={{ width: 'fit-content' }}>
                    <RadioButton
                      name="companyType"
                      checked={values.companyType == each.value ? true : false}
                      onChange={e => {
                        handleChange(e),
                          setFieldValue('companyType', each.value);
                        setTegiggerState(!triggeredState);
                      }}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className={`${comingSoon}`}>
                  <Modal
                    modalStyle={{ backgroundColor: 'rgba(10, 10, 10, 0.3)' }}
                    show={showModal}
                    setShow={setShowModal}
                    styleContainer={{
                      width: '395px'
                    }}
                  >
                    <div
                      style={{
                        borderBottom: '1px solid #DCE9F5',
                        position: 'relative',
                        top: '-15px'
                      }}
                    >
                      <h1 className="text-center p-5">Coming Soon</h1>
                    </div>
                  </Modal>
                </div>
              </div>
            );
          })}
          <div className="w-full md:hidden block">
            <button
              type="button"
              className="submitButton font-roboto text-white text-base w-48 "
              onClick={() => {
                if (values.companyType) {
                  setFieldValue('isShowFileds', true);
                }
              }}
            >
              NEXT
            </button>
          </div>
        </div>
      </div>
      <CompanyFileds
        lap={lap}
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        setFieldError={setFieldError}
        triggeredState={triggeredState}
        setShow={setShow}
        setType={setType}
        setText={setText}
        validateForm={validateForm}
        getCompanyList={getCompanyList}
        setComapnyList={setComapnyList}
        autoCompleteValue={autoCompleteValue}
        setAutoCompleteValue={setAutoCompleteValue}
      />
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

export default CompanyDetails;

export const CompanyFileds = ({
  lap,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  validateForm,
  triggeredState,
  setShow,
  setType,
  setText,
  getCompanyList,
  setComapnyList,
  autoCompleteValue,
  setAutoCompleteValue
}) => {
  const [listsofDataFiled, setListsOfDataFields] = useState([]);
  const [natureOfBusinessLists, setBusinessLists] = useState([
    { label: '', value: '' }
  ]);
  const [industryLists, setIndustryListsData] = useState([
    { label: '', value: '' }
  ]);
  const [subIndustryData, setSubIndustryData] = useState([
    { label: '', value: '' }
  ]);
  const [autoCompleteRunning, setAutoCompleteRunning] = useState(false);
  const commonStyles = `md:w-6/12 w-full mr-auto md:pr-7 my-3 md:pl-2 ${compnay_container}`;
  const commonInputEffect = { height: '52px', maxWidth: '100%' };
  const comonSelectContainerEffect = {
    minHeight: '52px',
    marginBottom: '0px',
    fontSize: '40px',
    alignItems: 'center'
  };
  const commonDropDownStles = {
    top: '52px',
    color: 'rgba(0,0,0,0.87)',
    fontSize: '16px',
    backgroundColor: '#fff',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontWeight: 400
  };

  const selectCommonDisplay = {
    fontSize: '14px',
    padding: '0 25px',
    alignItems: 'center',
    minHeight: '52px'
  };

  useEffect(() => {
    if (
      values.companyType == 'Proprietorship' ||
      values.companyType == 'Partnership'
    )
      setListsOfDataFields([
        'company_name',
        'nature_of_business',
        'industry_list',
        'sub_industry',
        'company_pan'
      ]);
    else if (
      values.companyType == 'Limited' ||
      values.companyType == 'Private Limited'
    )
      setListsOfDataFields([
        'auto_complete_cin',
        'cin',
        'nature_of_business',
        'industry_list',
        'sub_industry',
        'company_pan'
      ]);
    else if (values.companyType == 'LLP')
      setListsOfDataFields([
        'auto_complete_cin',
        'llpin',
        'nature_of_business',
        'industry_list',
        'sub_industry',
        'company_pan'
      ]);
  }, [triggeredState]);

  const submitValues = () => {
    if (values?.shouldDisabled) {
      navigate(staticData?.userKycLap || 'app/LAP/kyc');
      return;
    }
    setType('loading');
    setText('Submitting Please Wait...');
    setShow(true);
    let body = {
      companyType: values.companyType,
      natureOfBusinessId: values.nature_of_business.value,
      industryId: values.industry_list.value,
      subIndustryId: values.sub_industry.value,
      companyPan: values.company_pan,
      gstNumber: values.gstNumber
    };
    if (values.companyType == 'LLP') {
      body['cin'] = values.llpin;
    } else if (
      values.companyType != 'Proprietorship' &&
      values.companyType != 'Partnership'
    ) {
      body['cin'] = values.cin;
    }
    if (
      values.companyType == 'Proprietorship' ||
      values.companyType == 'Partnership'
    ) {
      body['companyName'] = values.company_name;
    } else {
      body['companyName'] = values.auto_complete_cin;
    }
    if (lap) {
      lapIndToComp(
        getApplicantionInfo().leadId,
        getApplicantionInfo().leadApplicantId,
        body
      )
        .then(res => {
          setLapInfo(body);
          if (res.error) {
            throw new Error(res);
          }
          setShow(false);
          if (values.companyType == 'Proprietorship')
            navigate(staticData?.userKyc || 'app/UserKyc');
          else {
            navigate(staticData?.userKycLap || 'app/LAP/kyc');
          }
        })
        .catch(error => {
          setType('fail');
          setText(
            _.get(error, 'response.data.message', 'Something went wrong!')
          );
          setShow(true);
        });
    } else {
      addSelpEmployeedDetails(
        getApplicantionInfo().leadId,
        getApplicantionInfo().leadApplicantId,
        body
      )
        .then(res => {
          if (res.error) {
            throw new Error(res);
          }
          setShow(false);
          handleSubmit();
        })
        .catch(error => {
          setType('fail');
          setText(
            _.get(error, 'response.data.message', 'Something went wrong!')
          );
          setShow(true);
        });
    }
  };
  const handleSubmition = () => {
    validateForm().then(res => {
      if (Object.keys(res).length == 0) {
        submitValues();
      } else {
        handleSubmit();
      }
    });
  };
  useEffect(() => {
    getnatureOfBusinessLists()
      .then(res => {
        let listData = {},
          totalData = [];
        if (res) {
          for (let i = 0; i < res.length; i++) {
            listData = {};
            listData['value'] = res[i].id;
            listData['label'] = res[i].name;
            totalData.push(listData);
          }
          setBusinessLists(totalData);
        }
      })
      .catch(error => {});
  }, []);

  const getAvailableIndustryLists = id => {
    setFieldValue('industry_list', { value: '', label: 'Choose Industry' });
    setFieldValue('sub_industry', { value: '', label: 'Choose Sub Industry' });
    setIndustryListsData([]);
    setSubIndustryData([]);

    getIndustryLists(id)
      .then(res => {
        let listData = {},
          totalData = [];

        if (res) {
          for (let i = 0; i < res.length; i++) {
            listData = {};
            listData['value'] = res[i].id;
            listData['label'] = res[i].name;
            totalData.push(listData);
          }
          setIndustryListsData(totalData);
        }
      })
      .catch(error => {});
  };
  const getAvailableGroupLists = id => {
    setFieldValue('sub_industry', { value: '', label: 'Choose Sub Industry' });
    setSubIndustryData([]);
    getSubIndustryData(id)
      .then(res => {
        let listData = {},
          totalData = [];

        if (res) {
          for (let i = 0; i < res.length; i++) {
            listData = {};
            listData['value'] = res[i].id;
            listData['label'] = res[i].name;
            totalData.push(listData);
          }
          setSubIndustryData(totalData);
        }
      })
      .catch(error => {});
  };
  const getListsOfCompany = e => {
    if (e) {
      setAutoCompleteRunning(true);
      getCompanyDetails(e)
        .then(res => {
          if (res.error) {
            throw new Error(res);
          }
          setComapnyList(res);
          setAutoCompleteRunning(false);
          setAutoCompleteValue(false);
        })
        .catch(error => {});
    }
  };

  const callDebouncer = _.debounce(e => getListsOfCompany(e), 1000);

  const getComapnyNewLists = e => {
    if (_.get(e, 'target.value', false)) callDebouncer(e.target.value);
  };

  const handleSelectedOption = value => {
    if (value?.cin && value?.name) {
      if (values.companyType != 'LLP') {
        setFieldValue('cin', value.cin);
        setFieldValue('auto_complete_cin', value.name);
      } else if (values.companyType == 'LLP') {
        setFieldValue('llpin', value.cin);
        setFieldValue('auto_complete_cin', value.name);
      }
      setAutoCompleteRunning(false);
    }
  };

  return (
    <div className={`w-full ${values.isShowFileds ? '' : 'hidden'} md:block`}>
      <div className="w-full flex flex-wrap mt-7 lg:w-10/12 ">
        {listsofDataFiled.includes('auto_complete_cin') ? (
          <div className={`${commonStyles}`}>
            <Autocomplete
              disabled={values?.shouldDisabled}
              getOptionDisabled={() => {
                if (values?.shouldDisabled) return true;
              }}
              name="auto_complete_cin"
              getOptionSelected={(option, value) => {}}
              getOptionLabel={option => option.name}
              options={getCompanyList}
              loading={autoCompleteRunning}
              onInputChange={getComapnyNewLists}
              value={autoCompleteValue}
              onChange={(event, newValue) => {
                setAutoCompleteValue(newValue);
                handleSelectedOption(newValue);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Company Name"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {autoCompleteRunning ? (
                          <CircularProgress color="inherit" size={30} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                />
              )}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('company_name') ? (
          <div className={`${commonStyles}`}>
            <CommonInput
              name="company_name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.company_name}
              stylesContainer={commonInputEffect}
              legendName="Company Name"
              error={touched.company_name && errors.company_name}
              errorMsg={errors.company_name}
              touched={touched.company_name}
              disabled={values?.shouldDisabled}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('cin') ? (
          <div className={`${commonStyles}`}>
            <CommonInput
              name="cin"
              onBlur={handleBlur}
              value={values.cin}
              stylesContainer={commonInputEffect}
              legendName="Enter CIN"
              error={touched.cin && errors.cin}
              errorMsg={errors.cin}
              disabled={true}
              touched={touched.cin}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('llpin') ? (
          <div className={`${commonStyles}`}>
            <CommonInput
              name="llpin"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.llpin}
              stylesContainer={commonInputEffect}
              legendName="Enter LLPIN"
              error={touched.llpin && errors.llpin}
              errorMsg={errors.llpin}
              touched={touched.llpin}
              disabled={true}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('nature_of_business') ? (
          <div className={`${commonStyles}`}>
            <CommonSelect sort={true}
              name="nature_of_business"
              value={values.nature_of_business}
              onChange={e => {
                setFieldValue('nature_of_business', {
                  value: e.value,
                  label: e.label
                }),
                  getAvailableIndustryLists(e.value);
              }}
              options={natureOfBusinessLists}
              isHoverEffect
              stylesContainer={comonSelectContainerEffect}
              dropdownStyle={commonDropDownStles}
              styleText={selectCommonDisplay}
              error={
                touched.nature_of_business &&
                get(errors, 'nature_of_business.value', false)
              }
              touched={touched.nature_of_business}
              disabled={values?.shouldDisabled}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('industry_list') ? (
          <div className={`${commonStyles}`}>
            <CommonSelect sort={true}
              name="industry_list"
              value={values.industry_list}
              onChange={e => {
                setFieldValue('industry_list', {
                  value: e.value,
                  label: e.label
                }),
                  getAvailableGroupLists(e.value);
              }}
              options={industryLists}
              isHoverEffect
              stylesContainer={comonSelectContainerEffect}
              dropdownStyle={commonDropDownStles}
              styleText={selectCommonDisplay}
              error={
                touched.industry_list &&
                get(errors, 'industry_list.value', false)
              }
              touched={touched.industry_list}
              disabled={values?.shouldDisabled}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('sub_industry') ? (
          <div className={`${commonStyles}`}>
            <CommonSelect sort={true}
              name="sub_industry"
              value={values.sub_industry}
              onChange={e => {
                setFieldValue('sub_industry', {
                  value: e.value,
                  label: e.label
                });
              }}
              options={subIndustryData}
              isHoverEffect
              stylesContainer={comonSelectContainerEffect}
              dropdownStyle={commonDropDownStles}
              styleText={selectCommonDisplay}
              error={touched.sub_industry && get(errors, 'state.value', false)}
              touched={touched.sub_industry}
              disabled={values?.shouldDisabled}
            />
          </div>
        ) : null}
        {listsofDataFiled.includes('company_pan') ? (
          <div className={`${commonStyles}`}>
            <CommonInput
              name="company_pan"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.company_pan}
              stylesContainer={commonInputEffect}
              legendName="Company PAN"
              error={touched.company_pan && errors.company_pan}
              errorMsg={errors.company_pan}
              touched={touched.company_pan}
              disabled={values?.shouldDisabled}
            />
          </div>
        ) : null}
      </div>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 "
        onClick={() => handleSubmition()}
        disabled={Object.keys(errors).length != 0 ? true : false}
      >
        NEXT
      </button>
    </div>
  );
};
